import {
  getAddressTypeContent,
  getFullAddress,
  getParcelDescriptionContent,
  getParcelNumberContent,
  getParcelStatusContent,
  transformDateWithMessage,
} from '../helpers/table';

export const ADDRESS_BOOK_CONFIG = {
  actionControlsType: 'menu',
  columns: {
    mobile: [
      {
        path: 'details',
        content: [
          { path: 'addressType', getter: getAddressTypeContent },
          { path: 'nickname' },
          { path: 'contactName' },
          { path: 'address', getter: getFullAddress },
        ],
      },
      { path: 'actionMenuBtn' },
    ],
    desktop: [
      { path: 'addressType', getter: getAddressTypeContent },
      { path: 'nickname', heading: 'Nickname' },
      { path: 'contactName', heading: 'Contact Name' },
      { path: 'address', heading: 'Address', getter: getFullAddress },
      { path: 'actionMenuBtn' },
    ],
  },
};

export const OVERVIEW_ADDRESS_BOOK_CONFIG = {
  actionControlsType: 'menu',
  columns: {
    mobile: [
      {
        path: 'details',
        heading: 'Details',
        content: [
          { path: 'addressType', getter: getAddressTypeContent },
          { path: 'nickname' },
          { path: 'contactName' },
          { path: 'address', getter: getFullAddress },
        ],
      },
      { path: 'actionMenuBtn' },
    ],
    desktop: [
      { path: 'addressType', getter: getAddressTypeContent },
      { path: 'nickname', heading: 'Nickname' },
      { path: 'contactName', heading: 'Contact Name' },
      { path: 'address', heading: 'Address', getter: getFullAddress },
      { path: 'actionMenuBtn' },
    ],
  },
};

export const ADDRESS_BOOK_MODAL_CONFIG = {
  actionControlsType: 'selectButton',
  columns: {
    mobile: [
      {
        path: 'details',
        content: [
          { path: 'addressType', getter: getAddressTypeContent },
          { path: 'nickname' },
          { path: 'contactName' },
          { path: 'address', getter: getFullAddress },
        ],
      },
      { path: 'actionSelectedButton' },
    ],
    desktop: [
      { path: 'addressType', getter: getAddressTypeContent },
      { path: 'nickname', heading: 'Nickname' },
      { path: 'contactName', heading: 'Contact Name' },
      { path: 'address', heading: 'Address', getter: getFullAddress },
      { path: 'actionSelectedButton' },
    ],
  },
};

export const PARCELS_CONFIG = {
  actionControlsType: 'menu',
  columns: {
    mobile: [
      {
        path: 'details',
        heading: 'Details',
        content: [
          { path: 'parcelNumber', getter: getParcelNumberContent },
          { path: 'recipient' },
          { path: 'postcode' },
          { path: 'description', getter: getParcelDescriptionContent },
          {
            path: 'ordered',
            getter: transformDateWithMessage('Ordered'),
          },
          {
            path: 'collected',
            getter: transformDateWithMessage('Collected'),
          },
          { path: 'status', getter: getParcelStatusContent },
        ],
      },
      { path: 'actionMenuBtn' },
    ],
    desktop: [
      {
        path: 'parcelNumber',
        getter: getParcelNumberContent,
        heading: 'Parcel Number',
      },
      { path: 'recipient', heading: 'Recipient' },
      { path: 'postcode', heading: 'Postcode' },
      {
        path: 'description',
        getter: getParcelDescriptionContent,
        heading: 'Description',
      },
      {
        path: 'ordered',
        getter: transformDateWithMessage('Ordered'),
        heading: 'Ordered',
      },
      {
        path: 'collected',
        getter: transformDateWithMessage('Collected'),
        heading: 'Collected',
      },
      { path: 'status', getter: getParcelStatusContent, heading: 'Tracking' },
      { path: 'actionMenuBtn' },
    ],
  },
};

export const RECENT_PARCELS_CONFIG = {
  actionControlsType: 'menu',
  columns: {
    mobile: [
      {
        path: 'details',
        heading: 'Details',
        content: [
          { path: 'recipient' },
          { path: 'description', getter: getParcelDescriptionContent },
          { path: 'status', getter: getParcelStatusContent },
        ],
      },
      { path: 'actionMenuBtn' },
    ],
    desktop: [
      { path: 'recipient', heading: 'Recipient' },
      {
        path: 'description',
        getter: getParcelDescriptionContent,
        heading: 'Description',
      },
      { path: 'status', getter: getParcelStatusContent, heading: 'Tracking' },
      { path: 'actionMenuBtn' },
    ],
  },
};
